{
  "zh-CN": {
    "actions": {
      "announcements": {
        "addPart": "添加",
        "removePart": "移除",
        "movePartUp": "上移",
        "movePartDown": "下移",
        "sendTest": "发送测试",
        "publish": "发送",
        "retry": "重试",
        "refreshEngagement": "刷新数据",
        "openPost": "打开帖子"
      },
      "admin": {
        "dashboard": {
          "reloadModels": "重新加载模型",
          "reloadScData": "重新加载 SC 数据",
          "reloadPaints": "重新加载涂装",
          "reloadModules": "重新加载模块",
          "reloadLoaners": "重新加载借用船"
        },
        "supporterContributions": {
          "syncFromPatreon": "从 Patreon 同步"
        },
        "imports": {
          "loadAll": "全部加载",
          "load": "加载",
          "loadScData": "加载 SC 数据",
          "loadShipMatrix": "加载舰船矩阵",
          "cleanup": "标记为失败",
          "cleanupSelected": "将所选标记为失败"
        }
      },
      "duplicate": "复制",
      "upgrade": "更新可用！",
      "backToHome": "规划新航线",
      "disableGrouping": "禁用分组",
      "enableGrouping": "启用分组",
      "groupedByModel": "按型号分组",
      "destroyAccount": "删除账户",
      "saveScreenshot": "保存为PNG",
      "resolve": "解决",
      "sortBy": "排序方式",
      "back": "返回",
      "open": "打开",
      "copy": "复制",
      "download": "下载",
      "zoom": "缩放",
      "more": "更多...",
      "export": "导出",
      "exportHangarLink": "导出到 hangar.link",
      "import": "导入",
      "here": "这里",
      "previous": "上一个",
      "next": "下一个",
      "cancel": "取消",
      "ok": "确定",
      "reset": "重置",
      "reload": "重新加载",
      "retry": "重试",
      "confirm": "确认",
      "showDetailPage": "详情页面",
      "showDetails": "显示详情",
      "hideDetails": "隐藏详情",
      "readMore": "阅读更多",
      "readLess": "收起",
      "showGuide": "显示指南",
      "showFleetchart": "舰队图表",
      "hideFleetchart": "默认视图",
      "fleetchartApp": {
        "useExtendedState": "以展开状态显示飞船",
        "useRetractedState": "以飞行状态显示飞船"
      },
      "showLabels": "显示标签",
      "hideLabels": "隐藏标签",
      "resetZoom": "重置缩放",
      "supportUs": "支持FleetYards.net",
      "installApp": {
        "cta": "安装应用",
        "later": "以后再说"
      },
      "supportHint": {
        "cta": "支持 FleetYards",
        "later": "稍后再说"
      },
      "login": "登录",
      "signUp": "注册",
      "confirmAccess": "确认密码",
      "sendConfirmAccessEmail": "发送确认邮件",
      "reset-password": "忘记密码？",
      "edit": "编辑",
      "clear": "清除",
      "done": "完成",
      "share": "分享",
      "change": "更改",
      "upload": "上传",
      "save": "保存",
      "enable": "启用",
      "disable": "禁用",
      "manage": "管理",
      "enableGlobally": "全局启用",
      "disableGlobally": "全局禁用",
      "addActor": "添加角色",
      "addGroup": "添加组",
      "editGroup": "编辑组",
      "remove": "移除",
      "reorder": "重新排序",
      "moveUp": "上移",
      "moveDown": "下移",
      "delete": "删除",
      "deleteSelected": "删除选中项",
      "enableSelected": "启用选中项",
      "disableSelected": "禁用选中项",
      "presets": {
        "choose": "选择图片",
        "remove": "移除图片"
      },
      "close": "关闭",
      "filter": "过滤",
      "showStatusColor": "显示状态颜色",
      "hideStatusColor": "隐藏状态颜色",
      "addToHangar": "添加到机库",
      "blueprint": {
        "own": "标记为已拥有",
        "unown": "取消已拥有标记"
      },
      "resetFilter": "重置过滤器",
      "requestPassword": "请求密码邮件",
      "changePassword": "更改密码",
      "updatePassword": "更新密码",
      "copyBackupCodes": "复制备份代码",
      "regenerate": "重新生成",
      "add": "添加",
      "create": "创建",
      "addToWishlist": "添加到愿望清单",
      "addVehicle": "添加飞船",
      "showTableView": "显示为列表",
      "showGridView": "显示为网格",
      "linkExisting": "链接现有",
      "loadMore": "加载更多",
      "unlink": "取消链接",
      "syncRsiBuybacks": "同步 RSI 回购",
      "syncRsiHangar": "同步RSI机库",
      "oauthApplications": {
        "create": "新建应用",
        "regenerateSecret": "重新生成密钥",
        "approve": "批准",
        "reject": "拒绝",
        "rejectSelected": "拒绝所选"
      },
      "oauthAuthorize": {
        "authorize": "授权",
        "deny": "拒绝"
      },
      "verifyWithCitizenId": "使用 Citizen iD 验证",
      "user": {
        "rsiVerification": {
          "verify": "通过 RSI 个人资料验证",
          "check": "立即检查",
          "checkIn": "%{seconds} 秒后可再次检查",
          "verifyWithExtension": "使用扩展验证",
          "copyToken": "复制验证码",
          "regenerateToken": "生成新的验证码",
          "revoke": "撤销"
        }
      },
      "oauth": {
        "signInWith": "通过以下方式登录",
        "google": "Google",
        "discord": "Discord",
        "bluesky": "BlueSky",
        "github": "GitHub",
        "twitch": "Twitch",
        "citizenid": "Citizen iD",
        "connected": {
          "google": "已连接到 Google",
          "discord": "已连接到 Discord",
          "bluesky": "已连接到 BlueSky",
          "github": "已连接到 GitHub",
          "twitch": "已连接到 Twitch",
          "citizenid": "已连接到 Citizen iD",
          "patreon": "已连接 Patreon"
        },
        "disconnect": {
          "google": "断开 Google 连接",
          "discord": "断开 Discord 连接",
          "bluesky": "断开 BlueSky 连接",
          "github": "断开 GitHub 连接",
          "twitch": "断开 Twitch 连接",
          "citizenid": "断开 Citizen iD 连接",
          "patreon": "断开 Patreon"
        },
        "patreon": "Patreon"
      },
      "compare": {
        "ships": "对比"
      },
      "cargoGrids": {
        "addShips": "添加飞船"
      },
      "tradeRoutes": {
        "pickShip": "选择飞船",
        "changeShip": "更换飞船",
        "editRun": "编辑",
        "doneEditing": "完成",
        "backToRuns": "返回所有航程",
        "showMore": "显示更多航程"
      },
      "hangar": {
        "editGroups": "Add or remove Groups",
        "editName": "Name your Ship",
        "manageLoadouts": "管理配置",
        "manageCargo": "管理货物",
        "useName": "Use Name",
        "destroyAll": "Remove all Ships",
        "showOnPublicHangar": "Make Public",
        "hideFromPublicHangar": "Hide from Public",
        "editGroupsSelected": "Add/Remove from Groups",
        "resetIngame": {
          "openModal": "数据重置后重置游戏内飞船",
          "moveToWishlist": "Move to Wishlist",
          "removeAll": "Remove all"
        }
      },
      "syncExtension": {
        "cancel": "取消",
        "start": "Start Sync",
        "retry": "重试同步",
        "close": "关闭",
        "refresh": "刷新页面"
      },
      "empty": {
        "hangarGuide": "Need Help?",
        "reset": "清除筛选"
      },
      "destroyFleet": "解散舰队",
      "restore": "恢复",
      "fleet": {
        "fidClaim": {
          "claim": "申领 %{fid}",
          "withdraw": "撤回申领",
          "useSuggestion": "使用 %{suggestion}",
          "endNow": "立即结束宽限期",
          "cancel": "取消申领"
        },
        "rsiVerification": {
          "verify": "验证",
          "regenerateToken": "生成新的验证码",
          "check": "立即检查",
          "copyToken": "复制验证码",
          "revoke": "撤销"
        },
        "join": "Join %{fleet}!",
        "leave": "Leave %{fleet}",
        "createInviteUrl": "Create Invite Urls",
        "inviteMember": "Invite new Member",
        "squadrons": {
          "create": "创建中队",
          "addMember": "添加成员",
          "removeMember": "移出中队",
          "addMembers": "添加 %{count} 名",
          "viewMembers": "中队成员",
          "viewShips": "中队舰船",
          "viewStats": "中队统计",
          "join": "加入团队",
          "leave": "退出",
          "requestJoin": "申请加入",
          "withdrawRequest": "撤回申请",
          "acceptRequest": "接受",
          "declineRequest": "拒绝",
          "promote": "晋升",
          "demote": "降级"
        },
        "manageInvites": "邀请",
        "worldmap": "世界地图",
        "starmap": "星图",
        "acceptInvite": "Accept Invitation",
        "declineInvite": "Decline Invitation",
        "acceptRequest": "accept Request",
        "declineRequest": "Decline Request",
        "members": {
          "invite": "Invite",
          "promote": "Promote",
          "demote": "Demote",
          "accept": "Accept",
          "decline": "Decline",
          "remove": "移除",
          "editRole": "编辑角色",
          "editNickname": "编辑昵称"
        },
        "inviteUrls": {
          "create": "Create new Invite Url"
        },
        "discord": {
          "test": "测试 Discord 连接",
          "installBot": "在您的 Discord 服务器中安装 Fleetyards 机器人"
        },
        "calendarSubscription": {
          "enable": "生成订阅链接",
          "rotate": "更换链接",
          "disable": "停用订阅"
        }
      },
      "model": {
        "gallery": "Gallery",
        "onSale": "On Sale: %{price}",
        "store": "RSI Page"
      },
      "models": {
        "sync": "从 RSI 同步",
        "syncMatrix": "同步矩阵",
        "syncScData": "同步 SC 数据",
        "importPaints": "导入涂装",
        "exchangeStoreImage": "使用 RSI 图片",
        "images": "图片",
        "openTableConfiguration": "打开表格配置"
      },
      "users": {
        "loginAs": "以用户身份登录",
        "resendConfirmation": "重新发送确认",
        "sendPasswordReset": "发送密码重置"
      },
      "unselect": "Unselect all Selected",
      "twoFactor": {
        "enable": "Enable Two-factor",
        "disable": "Disable Two-factor",
        "generateBackupCodes": "生成备用码"
      },
      "holoViewer": {
        "autoRotate": {
          "enable": "Enable auto rotate",
          "disable": "Disable auto rotate"
        },
        "zoom": {
          "enable": "Enable zoom",
          "disable": "Disable zoom"
        },
        "color": {
          "enable": "Enable colors",
          "disable": "Disable colors"
        }
      },
      "logistics": {
        "createInventory": "New Inventory",
        "submit": "Submit",
        "reject": "Reject",
        "cancel": "Cancel",
        "deposit": "Deposit",
        "withdraw": "Withdraw",
        "createItem": "Add Item",
        "importCsv": "Import CSV",
        "downloadTemplate": "Download Template",
        "destroyEntry": "Delete Entry",
        "editStockItem": "Edit Item",
        "destroyStockItem": "Delete Item",
        "editInventory": "Edit Inventory",
        "clearCargo": "清空货物",
        "viewCargoGrid": "查看货物网格",
        "sendTransfer": "发送",
        "moveStock": "移动",
        "transfer": "转移",
        "acceptTransfer": "接受",
        "declineTransfer": "拒绝",
        "cancelTransfer": "撤回",
        "reportTransfer": "举报",
        "resetToMax": "重置为最大值",
        "removeLine": "移除"
      },
      "adminNotifications": {
        "unread": "标记为未读",
        "archive": "归档",
        "unarchive": "移回收件箱",
        "readAll": "全部标记为已读",
        "destroyAll": "全部删除",
        "sortOldest": "最早优先",
        "sortNewest": "最新优先",
        "select": "选择通知",
        "readSelected": "将所选标记为已读",
        "unreadSelected": "将所选标记为未读",
        "archiveSelected": "归档所选",
        "unarchiveSelected": "将所选移回收件箱",
        "destroySelected": "删除所选"
      },
      "account": {
        "calendarSubscription": {
          "enable": "生成个人日历链接",
          "rotate": "更换链接",
          "disable": "停用订阅"
        }
      },
      "today": "今天",
      "fleets": {
        "missions": {
          "publish": "发布",
          "create": "创建任务",
          "edit": "编辑任务",
          "archive": "归档任务",
          "unarchive": "取消归档",
          "destroy": "永久删除",
          "addTeam": "添加小队",
          "addShip": "添加飞船",
          "addSlot": "添加席位",
          "viewMissions": "查看任务"
        },
        "tours": {
          "viewTours": "查看行程"
        },
        "events": {
          "create": "创建活动",
          "edit": "编辑活动",
          "spawn": "从此任务创建",
          "archive": "归档活动",
          "unarchive": "从归档中恢复",
          "syncToDiscord": "同步到 Discord",
          "destroy": "永久删除",
          "publish": "发布",
          "lockSignups": "锁定报名",
          "unlockSignups": "解锁报名",
          "start": "开始",
          "complete": "完成",
          "cancel": "取消",
          "signup": "报名",
          "withdraw": "取消报名",
          "kick": "移除报名",
          "addToCalendar": "添加到日历",
          "subscribe": "订阅",
          "setUpCalendar": "设置日历订阅",
          "assignSlot": "分配到席位",
          "reassignSlot": "移动到其他席位",
          "manageEventTeam": "管理活动团队",
          "grantRole": "授予角色",
          "revokeRole": "撤销",
          "addTeam": "添加小队"
        },
        "contracts": {
          "create": "创建合约",
          "save": "保存合约",
          "publish": "发布",
          "claim": "接下",
          "join": "申请加入",
          "release": "放弃",
          "fulfil": "标记为完成",
          "cancel": "取消合约",
          "edit": "编辑",
          "leave": "退出",
          "remove": "移除",
          "acceptCrew": "同意",
          "declineCrew": "拒绝",
          "addItem": "添加货物",
          "payouts": "分账"
        }
      },
      "notifications": {
        "unread": "标记为未读",
        "archive": "归档",
        "unarchive": "移回收件箱",
        "readAll": "全部标记为已读",
        "destroyAll": "全部删除",
        "settings": "通知设置",
        "sortOldest": "最早优先",
        "sortNewest": "最新优先",
        "openCenter": "通知",
        "pushEnable": "在此设备上开启",
        "pushDisable": "在此设备上关闭",
        "pushRemove": "移除",
        "select": "选择通知",
        "readSelected": "将所选标记为已读",
        "unreadSelected": "将所选标记为未读",
        "archiveSelected": "归档所选",
        "unarchiveSelected": "将所选移回收件箱",
        "destroySelected": "删除所选"
      },
      "unlistedModel": {
        "createModel": "创建飞船",
        "markAsPaint": "这是涂装",
        "ignore": "忽略",
        "noManufacturer": "此标识符无法解析出制造商",
        "alreadyExists": "%{name} 已在目录中",
        "link": "已在目录中",
        "markAsPaintSelected": "将所选标记为涂装",
        "ignoreSelected": "忽略所选"
      },
      "revert": "还原",
      "exportCsv": "导出 CSV",
      "exportAllCsv": "全部导出为 CSV",
      "imports": {
        "cancel": "取消",
        "downloadExample": "示例文件",
        "toggleDetails": "查看详情"
      },
      "selectFile": "选择文件",
      "applyGameFileValue": "采用",
      "applyAllGameFileValues": "全部采用",
      "payouts": {
        "archiveTour": "归档",
        "unarchiveTour": "恢复",
        "deleteTour": "删除",
        "openLedger": "打开分账簿",
        "addEntry": "记一笔",
        "addParticipant": "添加参与者",
        "settle": "结算并计算分账",
        "reopen": "重新打开",
        "confirm": "标记为已付",
        "unconfirm": "标记为未付",
        "createTour": "创建行程",
        "joinTour": "加入行程",
        "rotateInvite": "生成新链接",
        "askToJoin": "申请参加",
        "withdrawJoinRequest": "撤回申请",
        "approveJoinRequest": "通过",
        "declineJoinRequest": "拒绝",
        "approveExpense": "批准",
        "declineExpense": "拒绝"
      },
      "relationships": {
        "accept": "接受",
        "decline": "拒绝",
        "ignore": "忽略",
        "withdraw": "撤回",
        "end": "移除",
        "send": "发送请求",
        "user": {
          "add": "添加好友"
        },
        "fleet": {
          "add": "添加盟友"
        }
      },
      "supporterNomination": {
        "change": "更改舰队"
      }
    }
  }
}
